export default class TextareaResize {
    constructor() {
        this.textarea = '[data-textarea-resize]';

        this.init();

        $(document).on('input', this.textareaInputHandler.bind(this));
    }

    init() {
        this.checkTextareaSize();
    }

    textareaInputHandler(e) {
        this.textareaResize($(e.target));
    }

    checkTextareaSize() {
        const $textarea = $(this.textarea);

        if (!$textarea.length) {
            return;
        }

        $textarea.each((i, textarea) => {
            $(textarea).css('height', `${$(textarea)[0].scrollHeight}px`);
        });
    }


    textareaResize($textarea) {
        if (!$textarea.length) {
            return;
        }
            
        let adjustedHeight = $textarea[0].clientHeight;

        adjustedHeight = Math.max($textarea[0].scrollHeight, adjustedHeight);

        if (adjustedHeight > $textarea[0].clientHeight) {
            $textarea.css('height', `${adjustedHeight}px`);
        }
    }
};
